import { Stack } from '@mui/material';
import SuiTypography from '@upheal/design-system/components/legacy/Sui/SuiTypography';
import CardPageLayout from '@upheal/shared/components/shared/LayoutContainers/CardPageLayout';

function BrowserUnsupported() {
    return (
        <CardPageLayout showFooter={true}>
            <Stack spacing={3}>
                <SuiTypography
                    variant="h5"
                    color="body"
                    fontWeight="bold"
                    textAlign="center"
                >
                    Unsupported Browser
                </SuiTypography>
                <SuiTypography variant="body2" color="body" textAlign="center">
                    Please use one of the supported browsers: Google{'\xa0'}
                    Chrome, Microsoft{'\xa0'}Edge or Apple{'\xa0'}Safari.
                </SuiTypography>
            </Stack>
        </CardPageLayout>
    );
}

export default BrowserUnsupported;
